// Tinted background / foreground pairs for initials-only avatars.
// Each background stays light enough for its paired foreground to clear WCAG AA at 1rem/500.
const AVATAR_COLORS = [
    { bg: '#F4F0FF', fg: '#5B3FBF' }, // violet
    { bg: '#ECEEFF', fg: '#3B3FA8' }, // indigo
    { bg: '#EAF2FF', fg: '#1F5FAD' }, // blue
    { bg: '#E6F6F4', fg: '#17706A' }, // teal
    { bg: '#EAF6EE', fg: '#256E42' }, // green
    { bg: '#FFF6E5', fg: '#8A5A0B' }, // amber
    { bg: '#FFF0E8', fg: '#9C4A1A' }, // orange
    { bg: '#FEEDEF', fg: '#A62F45' }, // rose
    { bg: '#FCEDF7', fg: '#97317A' }, // pink
    { bg: '#EFF1F5', fg: '#44506B' }, // slate
];

const NEUTRAL_AVATAR_COLOR = { bg: '#F9F5FF', fg: '#000000' };

// Same name must always land on the same swatch, across sessions and across
// tables, so an investor isn't violet in one list and teal in another.
const hashName = (name) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
};

export const getInitials = (name) =>
    String(name ?? '')
        .split(' ')
        .filter(Boolean)
        .map((word) => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);

export const getAvatarColor = (name) => {
    if (!getInitials(name)) return NEUTRAL_AVATAR_COLOR;
    // Hash the whole name, not the initials — otherwise every "RM" in the
    // product collides on one swatch.
    const key = String(name).trim().toLowerCase().replace(/\s+/g, ' ');
    return AVATAR_COLORS[hashName(key) % AVATAR_COLORS.length];
};

export { AVATAR_COLORS, NEUTRAL_AVATAR_COLOR };
